import React from "react";
import PropTypes from "prop-types";
import { getTrueClasses } from "../../../helpers";
import "./index.scss";

const YouTube = ({ youTubeId }) => {
  return (
    <div className={getTrueClasses("GCL-YT")}>
      <iframe
        src={`https://www.youtube.com/embed/${youTubeId}?autoplay=1&modestbranding=1`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        title="youtube"
        className="GCL-YT__iframe"
      />
    </div>
  );
};
YouTube.propTypes = {
  closePopup: PropTypes.func,
};

export default YouTube;
